<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import config from '../../../../../../../configHttp';
	import {
		mxdj_query,
		mxdj_shuiyquery,
		mxdj_update,
		mxdj_shuiyupdate
	} from '../../../../../../api/hjbhs.js';
	export default {
		name: '',
		props: {
			//数据
			fuzjdata: {
				default: {
					biaosj: [{
						nsrmc: '',
						nsrsbh: '',
						companyNo: ''
					}],
					suosq: ''
				}
			},
			swrwzlList: {
				default: []
			},
			wrwlbList: {
				default: []
			},
			wrwpfljsffList: {
				default: []
			},
			searchdata: {
				default: {}
			}
		},
		data: function() {
			return {
				xiabiao: '',
				radioval: '',
				deleteIds: [],
				deleteIdssyjc: [],
				yuefdata: getdata().yuefdata,
				value: '',
				outlist: [],
				searchdiag: false,
				//水源信息库
				choosediagindex: 0,
				kudiag: false,
				boxdiaglist: [{}],

				TitleData: [{
						label: '城镇土地使用税'
					},
					{
						label: '从价计征房产税'
					},
					{
						label: '从租计征房产税'
					}
				],
				chooseindex: 0,
				boxlist: [{}, {}],
				choosedjindex: 0,
				boxdiaglist: [{}],
				choosediagindex: 0,
				syinfodiag: false,
				headData: getdata().headData,
				tableData: getdata().tableData,
				pagination: getdata().pagination
			};
		},
		created() {
			this.getmxdjInfo();
		},
		methods: {
			numValid(e, k) {
				const dotIndex = this.boxlist[k][e].indexOf(".");
				if (dotIndex !== -1) {
					const decimals = this.boxlist[k][e].slice(dotIndex + 1);
					if (decimals.length > 6) {
						this.boxlist[k][e] = this.boxlist[k][e].slice(0, dotIndex + 7);
					}
				}
			},
			forchoosemovediag(index) {
				if (this.choosediagindex != index) {
					this.choosediagindex = index;
				}
			},
			syjcxxk() {
				let parame = {
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
					current:1,
					size:999
				};
				mxdj_shuiyquery(parame).then(res => {
					if (res.data.code == 1) {
						if (res.data.data.records.length != 0) {
							this.boxdiaglist = res.data.data.records;
						}
						this.kudiag = true;
					}
				});
			},
			foraddupxxk(k) {
				let data = JSON.parse(JSON.stringify(this.boxdiaglist));
				for (var i = 0; i < data.length; i++) {
					if (data[i].paifkmc == null || data[i].paifkmc == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].wurwlb == null || data[i].wurwlb == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (!data[i].youxqq || data[i].youxqq == null || data[i].youxqq == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (!data[i].youxqz || data[i].youxqz == null || data[i].youxqz == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if ((data[i].shuiwrwzl == null || data[i].shuiwrwzl == '') && data[i].wurwlb == 'W') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].wurwmc == null || data[i].wurwmc == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].zhengszm == null || data[i].zhengszm == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].wurwpfljsff == null || data[i].wurwpfljsff == '') {
						this.$message.error('请先完善数据');
						return;
					}

					if (data[i].jisjsdw == null || data[i].jisjsdw == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].chanwxs == null || data[i].chanwxs == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].paiwxs == null || data[i].paiwxs == '') {
						this.$message.error('请先完善数据');
						return;
					}
				}
				let inte = k == 0 ? 0 : k - 1;
				this.boxdiaglist.splice(inte, 0, {
					nsrmc: this.fuzjdata.biaosj[0].nsrmc,
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
					companyNo: this.fuzjdata.biaosj[0].companyNo
				});
			},
			foradddownxxk(k) {
				let data = JSON.parse(JSON.stringify(this.boxdiaglist));
				for (var i = 0; i < data.length; i++) {
					if (data[i].paifkmc == null || data[i].paifkmc == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (!data[i].youxqq || data[i].youxqq == null || data[i].youxqq == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (!data[i].youxqz || data[i].youxqz == null || data[i].youxqz == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].wurwlb == null || data[i].wurwlb == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if ((data[i].shuiwrwzl == null || data[i].shuiwrwzl == '') && data[i].wurwlb == 'W') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].wurwmc == null || data[i].wurwmc == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].zhengszm == null || data[i].zhengszm == '') {
						this.$message.error('请先完善数据');
						return;
					}
					if (data[i].wurwpfljsff == null || data[i].wurwpfljsff == '') {
						this.$message.error('请先完善数据');
						return;
					}
				}

				this.boxdiaglist.splice(k + 1, 0, {
					nsrmc: this.fuzjdata.biaosj[0].nsrmc,
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
					companyNo: this.fuzjdata.biaosj[0].companyNo
				});
			},
			forupdatetypesyjcxxk(v, k) {
				if (v.id) {
					this.deleteIdssyjc.push(v.id); //删除的ids
				}
				if (this.boxdiaglist.length == 1) {
					this.boxdiaglist.splice(k, 1);
					this.boxdiaglist.splice(k, 0, {
						nsrmc: this.fuzjdata.biaosj[0].nsrmc,
						nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
						companyNo: this.fuzjdata.biaosj[0].companyNo
					});
				} else {
					this.boxdiaglist.splice(k, 1);
				}
			},
			baocunsyjc() {
				let data = JSON.parse(JSON.stringify(this.boxdiaglist));
				if (data.length >= 1) {
					for (var i = 0; i < data.length; i++) {
						if (data[i].paifkmc == null || data[i].paifkmc == '') {
							this.$message.error('请输入排放口名称或噪声源名称');
							return;
						}
						if (data[i].wurwlb == null || data[i].wurwlb == '') {
							this.$message.error('请选择污染物类别');
							return;
						}
						if (!data[i].youxqq || data[i].youxqq == null || data[i].youxqq == '') {
							this.$message.error('请选择税源有效期起');
							return;
						}
						if (!data[i].youxqz || data[i].youxqz == null || data[i].youxqz == '') {
							this.$message.error('请选择税源有效期止');
							return;
						}
						if ((data[i].shuiwrwzl == null || data[i].shuiwrwzl == '') && data[i].wurwlb == 'W') {
							this.$message.error('请选择水污染物种类');
							return;
						}
						if (data[i].wurwlb != 'W') {
							data[i].shuiwrwzl = null;
						}
						if (data[i].wurwmc == null || data[i].wurwmc == '') {
							this.$message.error('请输入染物名称（代码）');
							return;
						}
						if (data[i].zhengszm == null || data[i].zhengszm == '') {
							this.$message.error('请输入征收子目（代码）');
							return;
						}
						if (data[i].wurwpfljsff == null || data[i].wurwpfljsff == '') {
							this.$message.error('请选择 污染物排放量计算方法');
							return;
						}
						data[i].nsrsbh = this.fuzjdata.biaosj[0].nsrsbh;
						data[i].companyno = this.fuzjdata.biaosj[0].companyno;
					}
				}
				let params = {
					deleteIds: this.deleteIdssyjc,
					shuiyInfoListOutputDTOS: data,
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh
				};
				mxdj_shuiyupdate(params).then(res => {
					if (res.data.code == 1) {
						this.$message.success('保存成功');
						this.deleteIdssyjc = [];
						this.kudiag = false;
						this.getmxdjInfo();
					}
				});
			},

			forUpdateSearch() {
				this.searchdiag = true;
			},
			closeSearch() {
				this.searchdiag = false;
			},
			saveChange(e) {
				this.searchdiag = false;
			},
			confirmfilter(e) {
				this.headData = e.chooselist;
				this.outlist = e.nochooselist;
				this.shaidiag = false;
			},
			shaidiag() {},
			closeshaidiag() {
				this.shaidiag = false;
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				// this.gethjbhInfo();
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				// this.gethjbhInfo();
			},
			baocjcxx() {
				this.tableData.map(v => {
					if (v.id == this.radioval) {
						this.boxlist[this.xiabiao].shuiybh = v.shuiybh;
						this.boxlist[this.xiabiao].paifkmc = v.paifkmc;
						this.boxlist[this.xiabiao].shuiyId = v.id;
						this.boxlist[this.xiabiao].wurwmc = v.wurwmc;
						this.boxlist[this.xiabiao].tezzb = v.zhengszm;
						this.syinfodiag = false;
					}
				});
			},
			jcxxkxuanz(k) {
				this.xiabiao = k;
				let params = {
					cuttent: this.pagination.pageNum,
					size: this.pagination.pageSize,
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh
				};
				mxdj_shuiyquery(params).then(res => {
					if (res.data.code == 1) {
						if (res.data.data.records.length != 0) {
							res.data.data.records.tezzb = res.data.data.records.zhengszm
							this.tableData = res.data.data.records;
						}
						this.syinfodiag = true;
					}
				});
			},
			onInputFocus() {
				let benqi = 0;
				for (var i = 0; i < this.boxlist.length - 1; i++) {
					if (this.boxlist[i].benqybtse != '' && this.boxlist[i].benqybtse != null) {
						benqi += Number(this.boxlist[i].benqybtse == undefined || this.boxlist[i].benqybtse == '' ? 0 :
							Number(this.boxlist[i].benqybtse).toFixed(2));
					}
				}
				this.boxlist[this.boxlist.length - 1].benqi = `${benqi.toFixed(2)}`
			},
			//保存
			baocun() {
				let data = JSON.parse(JSON.stringify(this.boxlist));
				data.length = data.length - 1;
				if (data.length > 1) {
					for (var i = 0; i < data.length; i++) {
						if (data[i].yuef == null || data[i].yuef == '') {
							this.$message.error('请选择月份');
							return;
						}
						if (data[i].shuiybh == null || data[i].shuiybh == '') {
							this.$message.error('请选择税源编号');
							return;
						}
						if (data[i].feiqpfl == null || data[i].feiqpfl == '') {
							this.$message.error('请输入 废气（废水）排放量');
							return;
						}
						if (data[i].shicndz == null || data[i].shicndz == '') {
							this.$message.error('请输入 实测浓度值');
							return;
						}
						// if (data[i].yuendz == null || data[i].yuendz == '') {
						// 	this.$message.error('请输入 月均浓度');
						// 	return;
						// }
						// if (data[i].zuigndz == null || data[i].zuigndz == '') {
						// 	this.$message.error('请输入 最高浓度');
						// 	return;
						// }
						if (data[i].wurwpfl == null || data[i].wurwpfl == '') {
							this.$message.error('请输入 污染物排放量');
							return;
						}
						if (data[i].wurwdqz == null || data[i].wurwdqz == '') {
							this.$message.error('请输入 污染物当前值');
							return;
						}
						if (data[i].danwse == null || data[i].danwse == '') {
							this.$message.error('请输入 单位税额');
							return;
						}
					}
				} else if (data.length == 1) {
					if (
						(data[0].danwse != null && data[0].danwse != '') ||
						(data[0].wurwdqz != null && data[0].wurwdqz != '') ||
						(data[0].wurwpfl != null && data[0].wurwpfl != '') ||
						(data[0].zuigndz != null && data[0].zuigndz != '') ||
						(data[0].yuendz != null && data[0].yuendz != '') ||
						(data[0].shicndz != null && data[0].shicndz != '') ||
						(data[0].feiqpfl != null && data[0].feiqpfl != '') ||
						(data[0].shuiybh != null && data[0].shuiybh != '') ||
						(data[0].yuef != null && data[0].yuef != '')
					) {
						for (var i = 0; i < data.length; i++) {
							if (data[i].yuef == null || data[i].yuef == '') {
								this.$message.error('请选择月份');
								return;
							}
							if (data[i].shuiybh == null || data[i].shuiybh == '') {
								this.$message.error('请选择税源编号');
								return;
							}
							if (data[i].feiqpfl == null || data[i].feiqpfl == '') {
								this.$message.error('请输入 废气（废水）排放量');
								return;
							}
							if (data[i].shicndz == null || data[i].shicndz == '') {
								this.$message.error('请输入 实测浓度值');
								return;
							}
							// if (data[i].yuendz == null || data[i].yuendz == '') {
							// 	this.$message.error('请输入 月均浓度');
							// 	return;
							// }
							// if (data[i].zuigndz == null || data[i].zuigndz == '') {
							// 	this.$message.error('请输入 最高浓度');
							// 	return;
							// }
							if (data[i].wurwpfl == null || data[i].wurwpfl == '') {
								this.$message.error('请输入 污染物排放量');
								return;
							}
							if (data[i].wurwdqz == null || data[i].wurwdqz == '') {
								this.$message.error('请输入 污染物当前值');
								return;
							}
							if (data[i].danwse == null || data[i].danwse == '') {
								this.$message.error('请输入 单位税额');
								return;
							}
						}
					}
				}
				let params = {
					deleteIds: this.deleteIds,
					detailListOutputDTOS: data,
					id: this.fuzjdata.biaosj[0].id
				};
				if (Object.keys(data[0]).length == 0) {
					params.detailListOutputDTOS = []
				}
				mxdj_update(params).then(res => {
					if (res.data.code == 1) {
						this.$message.success('保存成功');
						this.deleteIds = [];
						this.getmxdjInfo();
					}
				});
			},
			calculateWurdlhzhlyl(wurwpfl, wurwdqz, index) {
				if (wurwdqz != undefined && wurwdqz != '') {
					if (parseFloat(wurwdqz) == 0) {
						this.boxlist[index].wurwdqz = '1';
						wurwdqz = '1';
					}
					this.boxlist[index].wurdlhzhlyl = (
						parseFloat(wurwpfl == undefined || wurwpfl == '' ? 0 : wurwpfl) / parseFloat(wurwdqz ==
							undefined || wurwdqz == '' ? 0 : wurwdqz)
					).toFixed(10);
				}
			},
			calculatebenqynse(wurdlhzhlyl, danwse, index) {
				this.boxlist[index].benqynse =
					parseFloat(!wurdlhzhlyl || wurdlhzhlyl == '' ? 0 : wurdlhzhlyl) * parseFloat(danwse == undefined ||
						danwse == '' ? 0 : danwse).toFixed(10);
				this.boxlist[index].benqynse = this.boxlist[index].benqynse + ''
				this.calculatebenqybtse(this.boxlist[index].benqynse, this.boxlist[index].benqjmse, this.boxlist[index]
					.benqyjse, index);
			},
			calculatebenqybtse(benqynse, benqjmse, benqyjse, index) {
				this.boxlist[index].benqybtse = `${
				parseFloat(benqynse == undefined || benqynse == '' ? 0 : benqynse) -
				parseFloat(benqjmse == undefined || benqjmse == '' ? 0 : benqjmse) -
				parseFloat(benqyjse == undefined || benqyjse == '' ? 0 : benqyjse).toFixed(10)}`

				this.onInputFocus();
			},
			getmxdjInfo() {
				if (this.fuzjdata.suosq == null || this.fuzjdata.suosq === undefined) {
					this.$message.info('请选择所属期');
					return;
				}
				//查询数据
				let params = {
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
					// nsrmc: this.fuzjdata.biaosj[0].nsrmc,
					hjbhId: this.fuzjdata.biaosj[0].id,
					suosq: this.fuzjdata.suosq,
					shuiybh: this.searchdata.shuiybh,
					paifkmc: this.searchdata.paifkmc
				};

				mxdj_query(params).then(res => {
					this.boxlist = [{
						nsrmc: this.fuzjdata.biaosj[0].nsrmc,
						nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
						companyNo: this.fuzjdata.biaosj[0].companyNo
					}];
					if (res.data.code == 1) {
						let benqi = 0;
						if (res.data.data.length != 0) {
							this.boxlist = res.data.data.map(v => {
								if (v.benqybtse != '' && v.benqybtse != null) {
									v.benqybtse = Number(v.benqybtse);
								}
								if (v.companyNo == '' || v.companyNo == null) {
									v.companyNo = this.fuzjdata.biaosj[0].companyNo;
								}
								return v;
							});
							this.boxlist.forEach(v => {
								if (v.benqybtse != '' && v.benqybtse != null) {
									benqi += Number(v.benqybtse.toFixed(2));
								}
							});
							console.log(this.boxlist)
						} else {
							this.boxlist[0].benqynse = '0';
							this.boxlist[0].benqjmse = '0';
							this.boxlist[0].benqyjse = '0';
							this.boxlist[0].benqybtse = '0';
							this.boxlist[0].danwse = '0';
						}
						this.boxlist.push({
							benqi: benqi,
						});
						console.log(this.boxlist)

					}
				});
			},
			foraddup(k) {
				let data = JSON.parse(JSON.stringify(this.boxlist));
				data.length = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					if (data[i].yuef == null || data[i].yuef == '') {
						this.$message.error('请选择月份');
						return;
					}
					if (data[i].shuiybh == null || data[i].shuiybh == '') {
						this.$message.error('请选择税源编号');
						return;
					}
					if (data[i].feiqpfl == null || data[i].feiqpfl == '') {
						this.$message.error('请输入 废气（废水）排放量');
						return;
					}
					if (data[i].shicndz == null || data[i].shicndz == '') {
						this.$message.error('请输入 实测浓度值');
						return;
					}
					// if (data[i].yuendz == null || data[i].yuendz == '') {
					// 	this.$message.error('请输入 月均浓度');
					// 	return;
					// }
					// if (data[i].zuigndz == null || data[i].zuigndz == '') {
					// 	this.$message.error('请输入 最高浓度');
					// 	return;
					// }
					if (data[i].wurwpfl == null || data[i].wurwpfl == '') {
						this.$message.error('请输入 污染物排放量');
						return;
					}
					if (data[i].wurwdqz == null || data[i].wurwdqz == '') {
						this.$message.error('请输入 污染物当前值');
						return;
					}
					if (data[i].danwse == null || data[i].danwse == '') {
						this.$message.error('请输入 单位税额');
						return;
					}
				}
				let inte = k == 0 ? 0 : k - 1;
				this.boxlist.splice(inte, 0, {
					nsrmc: this.fuzjdata.biaosj[0].nsrmc,
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
					companyNo: this.fuzjdata.biaosj[0].companyNo,
					benqynse: '0',
					benqjmse: '0',
					benqyjse: '0',
					benqybtse: '0'
				});
			},
			foradddown(k) {
				let data = JSON.parse(JSON.stringify(this.boxlist));
				data.length = data.length - 1;
				for (var i = 0; i < data.length; i++) {
					if (data[i].yuef == null || data[i].yuef == '') {
						this.$message.error('请选择月份');
						return;
					}
					if (data[i].shuiybh == null || data[i].shuiybh == '') {
						this.$message.error('请选择税源编号');
						return;
					}
					if (data[i].feiqpfl == null || data[i].feiqpfl == '') {
						this.$message.error('请输入 废气（废水）排放量');
						return;
					}
					if (data[i].shicndz == null || data[i].shicndz == '') {
						this.$message.error('请输入 实测浓度值');
						return;
					}
					// if (data[i].yuendz == null || data[i].yuendz == '') {
					// 	this.$message.error('请输入 月均浓度');
					// 	return;
					// }
					// if (data[i].zuigndz == null || data[i].zuigndz == '') {
					// 	this.$message.error('请输入 最高浓度');
					// 	return;
					// }
					if (data[i].wurwpfl == null || data[i].wurwpfl == '') {
						this.$message.error('请输入 污染物排放量');
						return;
					}
					if (data[i].wurwdqz == null || data[i].wurwdqz == '') {
						this.$message.error('请输入 污染物当前值');
						return;
					}
					if (data[i].danwse == null || data[i].danwse == '') {
						this.$message.error('请输入 单位税额');
						return;
					}
				}
				this.boxlist.splice(k + 1, 0, {
					nsrmc: this.fuzjdata.biaosj[0].nsrmc,
					nsrsbh: this.fuzjdata.biaosj[0].nsrsbh,
					companyNo: this.fuzjdata.biaosj[0].companyNo,
					benqynse: '0',
					benqjmse: '0',
					danwse: '0',
					benqyjse: '0',
					benqybtse: '0',
				});
			},
			forupdatetype(v, k) {
				if (v.id) {
					this.deleteIds.push(v.id); //删除的ids
				}
				if (this.boxlist.length == 2) {
					this.boxlist.splice(k, 1);
					this.boxlist.splice(k, 0, {});
				} else {
					this.boxlist.splice(k, 1);
				}
				let benqi = 0;
				for (var i = 0; i < this.boxlist.length - 1; i++) {
					console.log(this.boxlist)
					if (this.boxlist[i].benqybtse != '' && this.boxlist[i].benqybtse != null) {
						benqi += Number(this.boxlist[i].benqybtse == undefined || this.boxlist[i].benqybtse == '' ? 0 :
							this.boxlist[i].benqybtse.toFixed(2));
					}
				}
				this.boxlist[this.boxlist.length - 1].benqi = `${benqi.toFixed(2)}`
			},
			forchoosemovediag(index) {
				if (this.choosediagindex != index) {
					this.choosediagindex = index;
				}
			},
			forchoosemove(index) {
				if (this.choosedjindex != index) {
					this.choosedjindex = index;
				}
			},

			submitSearch() {
				this.pagination.pageNum = 1;
				this.pagination.paginationkey++;
				this.getmxdjInfo();
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>